import { useMemo } from 'react'
import Label from '../../../ui/Label'
import { useDispatch, useSelector } from 'react-redux';
import { selectNewProductCategoryId, selectNewProductSize, updateNewProduct } from '../../../../features/product/productSlice';
import Loading from '../../../ui/Loading';
import { useMasterData } from '../../../../hooks/api/useMasterData';
import { CATEGORY, PRODUCT_SIZE } from '../../../../constant/constant';

export default function ProdModSizes() {

    const dispatch = useDispatch()
    const prodSize = useSelector(selectNewProductSize)
    const categoryId = useSelector(selectNewProductCategoryId);
    const {  getSizes, isLoadingGetSizes, isErrorGetSizes, errorMessageGetSizes, } = useMasterData()

    const excludedSizesByCategory: Record<number, number[]> = {
        [CATEGORY.bottleDrinks.id]: [
            PRODUCT_SIZE.s8oz.id,
            PRODUCT_SIZE.s12oz.id,
            PRODUCT_SIZE.s16oz.id,
        ],
        [CATEGORY.pastries.id]: [
            PRODUCT_SIZE.s8oz.id,
            PRODUCT_SIZE.s12oz.id,
            PRODUCT_SIZE.s16oz.id,
        ],
        [CATEGORY.capitalExclusives.id]: [
            PRODUCT_SIZE.sNone.id,
        ],
        [CATEGORY.chocolateAndCocoa.id]: [
            PRODUCT_SIZE.sNone.id,
        ],
        [CATEGORY.hotCoffeeClassics.id]: [
            PRODUCT_SIZE.sNone.id,
        ],
        [CATEGORY.icedCoffeeClassics.id]: [
            PRODUCT_SIZE.sNone.id,
        ],
        [CATEGORY.refresher.id]: [
            PRODUCT_SIZE.sNone.id,
        ],
    };

    const filteredSizes = useMemo(() => {
        if (!getSizes) return [];

        const activeSizes = getSizes.filter(size => size.isActive);

        if (categoryId === undefined) return activeSizes;

        const excludedSizes = excludedSizesByCategory[categoryId] ?? [];

        return activeSizes.filter(
            size => !excludedSizes.includes(size.sizeId)
        );
    }, [getSizes, categoryId]);
    

    return (
        <div className=''>
            <Label label={'Select size *'}/>
            <div className='flex space-x-2'>
                { isLoadingGetSizes ? (
                    <div className='flex justify-center items-center w-full'>
                        <Loading setH={'h-[20px]'}/>
                    </div>
                ) : isErrorGetSizes ? (
                    <div className='flex justify-center items-center w-full'>
                        <p className={`text-red-500 text-xs`}>{errorMessageGetSizes}</p>
                    </div>
                ) : (
                    filteredSizes.map((size) => (
                        <div
                            key={size.sizeId}
                            onClick={() => {dispatch(updateNewProduct({ size: { id: size.sizeId, label: size.size } }))}}
                            className={`border py-0.5 px-1.5 text-xs rounded cursor-pointer select-none transition-all 
                                ${ prodSize?.id === size.sizeId
                                    ? "border-cbColor bg-orange-100 font-medium"
                                    : "border-gray-300 hover:border-gray-400"
                                }
                            `}
                        >
                            {size.size}
                        </div>
                    ))
                )}
            </div>
        </div>
    )
}
